import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { PolicyService } from 'gw-capability-policy';
import {
    withApplicationPropertyContext
} from 'tdic-components-platform-react';
import { EmailUtil } from 'gw-portals-util-js';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './TermsAndConditions.metadata.json5';
import styles from './TermsAndConditions.module.scss';

import './TermsAndConditions.message';

const TermsAndConditions = (props) => {
    const {
        tncTransactionTypesSubTypes, isAuthorisedUser, loggedUserContact,
        tncAcceptedStatus, history, termData: terms, getEffectiveUserContactSummary
    } = props;
    const { location } = history;
    const successPath = _.get(location, 'state.successPath', '/');
    const { authHeader, email, user_name: userName } = useAuthentication();
    const [acceptCheckbox, setAcceptCheckbox] = useState(false);
    const [tncCount, setTnCCount] = useState(-1);
    const updateCheckBox = useCallback(() => setAcceptCheckbox(!acceptCheckbox), [acceptCheckbox]);
    const tncType = _.find(tncTransactionTypesSubTypes, { transaction_Type: 'Login' });
    const role = isAuthorisedUser ? 'AuthorisedUser' : 'PolicyHolder';
    const tncSubType = _.find(tncType.transactionSubTypes, { transaction_SubType: role });

    useEffect(() => {
        if (_.isEmpty(loggedUserContact) && getEffectiveUserContactSummary) {
            getEffectiveUserContactSummary();
        }
        const request = {
            email_Address: EmailUtil.checkEmailValidity(email) ? email : userName,
            acceptance: 1,
            Transaction_Type: _.get(tncType, 'id'),
            Transaction_SubTypes: [
                _.get(tncSubType, 'id')
            ]
        };

        PolicyService.getAcceptedTnCCount(request, authHeader)
            .then(setTnCCount);
    // Execute once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const RenderComponent = (useCallback(() => {
        const dynamicTermsContent = terms.Content + terms.CSSCode;
        // eslint-disable-next-line react/no-danger
        return <div className="terms-and-conditions" dangerouslySetInnerHTML={{ __html: dynamicTermsContent || '' }} />;
    }, [terms]));

    const handleSaveAcceptance = useCallback(() => {
        const reqOption = {
            Version: terms.Version,
            acceptance: 1,
            Transaction_Type: _.get(tncType, 'id'),
            Transaction_SubTypes: [_.get(tncSubType, 'id')],
            email_Address: EmailUtil.checkEmailValidity(email) ? email : userName
        };
        PolicyService
            .saveUserTermsAndConditions(reqOption, authHeader)
            .then((data) => {
                if (data) {
                    if (!isAuthorisedUser && tncCount === 0) {
                        return history.push('/user-email-confirmation');
                    }
                    return history.push(successPath);
                }
                return null;
            });
    }, [terms.Version, tncType, tncSubType, email, userName, authHeader, isAuthorisedUser,
        tncCount, history, successPath]);

    if (tncAcceptedStatus) {
        return <Redirect to={{ pathname: successPath }} />;
    }

    const overrideProps = {
        tcCheckbox: {
            value: acceptCheckbox,
            onValueChange: updateCheckBox
        },
        tcSubmitButton: {
            disabled: !acceptCheckbox
        },
        tcLink: {
            href: _.get(appConfig, `tdic.termsOfUseEnternalLink.${process.env.NODE_ENV}`, _.get(appConfig, 'tdic.termsOfUseEnternalLink.development'))
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            rendercomponent: RenderComponent
        },
        resolveCallbackMap: {
            onSaveAcceptance: handleSaveAcceptance
        }
    };
    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
};

TermsAndConditions.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    tncTransactionTypesSubTypes: PropTypes.shape([]).isRequired,
    isAuthorisedUser: PropTypes.bool.isRequired
};

export default withRouter(withApplicationPropertyContext(TermsAndConditions));
